import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketEngine1lh73ie4wh0m5 as WebSocketEngine } from './WebSocketEngine.js.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { GraphQLWsProtocol3nqe2321ot0cb as GraphQLWsProtocol } from './GraphQLWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { awaitClose10k42f6qjplpu as awaitClose } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { WebSocketPool28m608awosr6h as WebSocketPool } from './internal/WebSocketPool.mjs';
import { callbackFlow1g384rkuy0hni as callbackFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ChannelResult2y4k69ac6y3du as ChannelResult } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WebSocketNetworkTransport$Builder$build$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return null;
  }), 0);
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.u64_1 = null;
        this.v64_1 = null;
        this.w64_1 = null;
        this.x64_1 = null;
        this.y64_1 = null;
        this.z64_1 = null;
        this.a65_1 = null;
        this.b65_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      q64(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.u64_1 = serverUrl;
        return this;
      }
      c65(idleTimeout) {
        // Inline function 'kotlin.apply' call
        this.z64_1 = idleTimeout;
        return this;
      }
      v39() {
        var tmp0_elvis_lhs = this.v64_1;
        var tmp5_webSocketEngine = tmp0_elvis_lhs == null ? WebSocketEngine() : tmp0_elvis_lhs;
        var tmp6_serverUrl = this.u64_1;
        var tmp1_elvis_lhs = this.z64_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(60, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp7_idleTimeout = tmp;
        var tmp2_elvis_lhs = this.w64_1;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          tmp_1 = new (GraphQLWsProtocol())(WebSocketNetworkTransport$Builder$build$slambda());
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp8_wsProtocol = tmp_1;
        var tmp9_pingInterval = this.y64_1;
        var tmp3_elvis_lhs = this.x64_1;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new (Duration())(tmp_3)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp_2 = toDuration(10, DurationUnit_SECONDS_getInstance());
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var tmp10_connectionAcknowledgeTimeout = tmp_2;
        var tmp4_elvis_lhs = this.a65_1;
        var tmp11_parserFactory = tmp4_elvis_lhs == null ? new (DefaultSubscriptionParserFactory())(get_impl(this.b65_1)) : tmp4_elvis_lhs;
        return new (WebSocketNetworkTransport())(tmp5_webSocketEngine, tmp6_serverUrl, tmp8_wsProtocol, tmp10_connectionAcknowledgeTimeout, tmp9_pingInterval, tmp7_idleTimeout, tmp11_parserFactory);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
function WebSocketNetworkTransport$execute$slambda($renewUuid, $request, this$0) {
  return constructCallableReference(($this$callbackFlow, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if ($renewUuid._v) {
      tmp = $request.x43().q42(uuid4()).v39();
    } else {
      tmp = $request;
    }
    var newRequest = tmp;
    $renewUuid._v = true;
    var operationListener = new (DefaultOperationListener())(newRequest, $this$callbackFlow, this$0.h6a_1.j6a($request));
    var webSocket = this$0.i6a_1.s6a(newRequest);
    webSocket.g6b(newRequest, operationListener);
    yield* awaitClose($this$callbackFlow, () => {
      webSocket.h6b(newRequest);
      return Unit_instance;
    }, $completion);
    return Unit_instance;
  }), 1);
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout, parserFactory) {
        this.b6a_1 = webSocketEngine;
        this.c6a_1 = serverUrl;
        this.d6a_1 = wsProtocol;
        this.e6a_1 = connectionAcknowledgeTimeout;
        this.f6a_1 = pingInterval;
        this.g6a_1 = idleTimeout;
        this.h6a_1 = parserFactory;
        this.i6a_1 = new (WebSocketPool())(this.b6a_1, this.c6a_1, this.d6a_1, this.e6a_1, this.f6a_1, this.g6a_1);
      }
      x65(request) {
        var renewUuid = {_v: false};
        var flow = callbackFlow(WebSocketNetworkTransport$execute$slambda(renewUuid, request, this));
        return buffer(flow, 2147483647);
      }
      n10() {
        this.i6a_1.m6();
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport');
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function errorResponse($this, cause) {
  return Builder().i44($this.i6b_1.g43_1, $this.i6b_1.h43_1).n44(cause).v39();
}
var DefaultOperationListenerClass;
function DefaultOperationListener() {
  if (DefaultOperationListenerClass === VOID) {
    class $ {
      constructor(request, producerScope, parser) {
        this.i6b_1 = request;
        this.j6b_1 = producerScope;
        this.k6b_1 = parser;
      }
      l6b(response) {
        var tmp0_safe_receiver = this.k6b_1.m6b(response);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.j6b_1.x1b(tmp0_safe_receiver);
          new (ChannelResult())(tmp$ret$0);
        }
      }
      n6b() {
        this.j6b_1.i1c();
      }
      o6b(payload) {
        this.j6b_1.x1b(errorResponse(this, SubscriptionOperationException().e4h(this.i6b_1.g43_1.operationName(), payload)));
        this.j6b_1.i1c();
      }
      p6b(cause) {
        this.j6b_1.x1b(errorResponse(this, cause));
        this.j6b_1.i1c();
      }
    }
    initMetadataForClass($, 'DefaultOperationListener');
    DefaultOperationListenerClass = $;
  }
  return DefaultOperationListenerClass;
}
var DefaultSubscriptionParserFactoryClass;
function DefaultSubscriptionParserFactory() {
  if (DefaultSubscriptionParserFactoryClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl) {
        this.q6b_1 = incrementalDeliveryProtocolImpl;
      }
      j6a(request) {
        return new (DefaultSubscriptionParser())(this.q6b_1, request);
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParserFactory');
    DefaultSubscriptionParserFactoryClass = $;
  }
  return DefaultSubscriptionParserFactoryClass;
}
var DefaultSubscriptionParserClass;
function DefaultSubscriptionParser() {
  if (DefaultSubscriptionParserClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl, request) {
        this.r6b_1 = request;
        this.s6b_1 = incrementalDeliveryProtocolImpl.n67();
        var tmp = this;
        var tmp0_elvis_lhs = this.r6b_1.k43_1.g48(Key_getInstance());
        tmp.t6b_1 = tmp0_elvis_lhs == null ? Key_getInstance().u47_1 : tmp0_elvis_lhs;
      }
      m6b(response) {
        var responseMap = (!(response == null) ? isInterface(response, KtMap()) : false) ? response : null;
        if (responseMap == null) {
          return Builder().i44(this.r6b_1.g43_1, this.r6b_1.h43_1).n44(DefaultApolloException().d45('Invalid payload')).v39();
        }
        var tmp;
        if (isDeferred(responseMap)) {
          tmp = to(this.s6b_1.z67(responseMap), this.s6b_1.v67());
        } else {
          tmp = to(responseMap, null);
        }
        var _destruct__k2r9zo = tmp;
        var payload = _destruct__k2r9zo.df();
        var deferredFragmentIdentifiers = _destruct__k2r9zo.ef();
        var apolloResponse = toApolloResponse(jsonReader(payload), this.r6b_1.g43_1, this.r6b_1.h43_1, this.t6b_1, deferredFragmentIdentifiers);
        if (!this.s6b_1.w67()) {
          this.s6b_1.r3q();
        }
        var tmp_0;
        if (this.s6b_1.x67()) {
          tmp_0 = null;
        } else {
          tmp_0 = apolloResponse;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParser');
    DefaultSubscriptionParserClass = $;
  }
  return DefaultSubscriptionParserClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.w4().t2('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder1suvx83rlbrz1,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
